'use client';
import { useEffect, useRef, useState } from 'react';

export const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState('up');
  const lastScrollY = useRef(0);
  const scrollDownThreshold = 10;
  const scrollUpThreshold = 0;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const effectiveThreshold =
        currentScrollY > lastScrollY.current
          ? scrollDownThreshold
          : scrollUpThreshold;

      if (Math.abs(currentScrollY - lastScrollY.current) < effectiveThreshold) {
        return;
      }
      if (currentScrollY > lastScrollY.current) {
        setScrollDirection('down');
      } else if (currentScrollY < lastScrollY.current) {
        setScrollDirection('up');
      }
      lastScrollY.current = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return scrollDirection;
};
